module.exports = __webpack_public_path__ + "img/20190703152622560.b0a78d10.png";